import type { ReactElement } from 'react';
import { AgentResourcesProvider } from './AgentResources.Container';
import { ContextSelectorContainer } from './ContextSelector.Container';
import { ChatHeaderController } from './Header.Controller';

function ChatHeader(): ReactElement {
  return (
    <ContextSelectorContainer>
      <AgentResourcesProvider>
        <ChatHeaderController />
      </AgentResourcesProvider>
    </ContextSelectorContainer>
  );
}

export { ChatHeader };
